import { Component, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { fritzschoff } from '@env/secrets'
import { Subscription } from 'rxjs';

@Component({
  selector: 'tonteppich-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnDestroy {

  private sub: Subscription;

  emailForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    message: new FormControl('', [Validators.required, Validators.minLength(10)])
  })

  constructor(private http: HttpClient) { }

  sendEmail() {
    this.sub = this.http.post(fritzschoff.emailAPI.tonteppich.contact,
      { msg: this.emailForm.get('message').value, email: this.emailForm.get('email').value }).subscribe()
    this.emailForm.reset();
  }

  ngOnDestroy() {
    if (this.sub) this.sub.unsubscribe();
  }
}
